import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="public-container">
      <Header subtitle="Encuesta de Clima Laboral 2025" />
      <main className="public-main">
        <div className="public-card">
          <div className="public-icon">&#128220;</div>
          <h1 className="public-title">Encuesta de Clima Laboral</h1>
          <p className="public-subtitle">
            Para acceder a la encuesta, utiliza el enlace personalizado
            que has recibido en tu correo electrónico corporativo.
          </p>

          <div className="public-info">
            <strong>¿Cómo acceder?</strong><br /><br />
            1. Revisa tu correo electrónico corporativo<br />
            2. Haz clic en el enlace personalizado que te hemos enviado<br />
            3. Introduce tu email para verificar tu identidad<br />
            4. Completa la encuesta<br /><br />
            <strong>Información importante:</strong><br />
            La encuesta es 100% anónima. La verificación solo controla el acceso,
            tus respuestas no se vincularán a tu identidad.
            <br /><br />
            Si no has recibido el correo, contacta con el departamento de RRHH.
          </div>
        </div>

        <div className="public-admin-link">
          <span className="link" onClick={() => navigate('/admin')}>
            Acceso Administración
          </span>
        </div>
      </main>
    </div>
  );
}

export default Home;
